export * from 'server/models/PSixVesselParticular';


// WEBPACK FOOTER //
// ./data/models/PSixVesselParticular.ts